import React, { FC } from 'react'

import { Card } from 'src/components/atoms'
import { ExternalUserManagement } from 'src/components/organisms'

import { ExternalUserDetailEntity } from 'src/types'

type Props = {
  user: ExternalUserDetailEntity
  className?: string
}

export const ExternalUserManagementCard: FC<Props> = ({ user, className }) => {
  return (
    <div className={className}>
      <Card padding="--s1">
        <ExternalUserManagement user={user} />
      </Card>
    </div>
  )
}
